export default __webpack_public_path__ + "static/media/irysLogo.9aa0e58e.svg";